'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _sampleClickthrough = require('./sample-clickthrough');

var _sampleClickthrough2 = _interopRequireDefault(_sampleClickthrough);

var _simpleEntry = require('./simple-entry');

var _simpleEntry2 = _interopRequireDefault(_simpleEntry);

var _requestLoginLink = require('./request-login-link');

var _requestLoginLink2 = _interopRequireDefault(_requestLoginLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class Auth
  * Checks to see if the expo requires users to log in.
  * If so, prompts users to authenticate before displaying
  * expo content.
  * @prop {Object} stage - the stage representing the entry to the expo
  * to display behind the login panel.
  * @prop {URLString} logo - a url to a logo to display in the login panel
  * @prop {String} entry - the html for the entry page
  */
var Auth = function (_Component) {
  _inherits(Auth, _Component);

  /** @constructor
    * Constructs a new instance of the Auth component
    */
  function Auth(props) {
    _classCallCheck(this, Auth);

    var _this = _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).call(this, props));

    _this.state = {
      loggedIn: false,
      showLoginRequest: false,
      newLoginLinkRequired: false
    };
    _this.attemptLogin = _this.attemptLogin.bind(_this);
    return _this;
  }
  /** @method attemptLogin
    * Attempts to log the user in if they came from
    * a firebase signin link.
    */


  _createClass(Auth, [{
    key: 'attemptLogin',
    value: function attemptLogin() {
      var _this2 = this;

      // Firebase must be loaded
      if (!window.vexpo && !window.vexpo.firebase) return;
      // Attempt Email Link Login
      if (window.vexpo.firebase.auth().isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        var email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt('Please provide your email for confirmation');
        }
        // The client SDK will parse the code from the link for you.
        window.vexpo.firebase.auth().signInWithEmailLink(email, window.location.href).then(function (result) {
          // clear the search and hash string in the address
          //window.history.replaceState({}, document.title, "/");
          // You can access the new user via result.user
          _this2.setState({ user: result.user });
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser
        }).catch(function (error) {
          window.localStorage.removeItem('emailForSignIn');
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          if (error.code === 'auth/invalid-action-code') {
            _this2.setState({
              showLoginRequest: true,
              loginRequestMessage: 'That link has already been used or expired.  Please request a new one.'
            });
          }
        });
      }

      // Attempt custom JWT login
      var match = /token=([^&]+)/.exec(window.location.href);
      if (match) {
        firebase.auth().signInWithCustomToken(match[1]).catch(function (error) {
          // Handle Errors here.
          console.error(error.code, error.message);
        });
      }
    }
    /** @method componentDidMount
      * Listens for changes to auth state
      */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      if (window.vexpo.firebase) {
        window.vexpo.requestLoginLink = function () {
          _this3.setState({ showLoginRequest: true });
        };
        window.vexpo.firebase.auth().onAuthStateChanged(function (user) {
          if (user) {
            _this3.setState({ loggedIn: true });
            if (window.vexpo && window.vexpo.sound) window.vexpo.sound.unshush();
            if (window.vexpo && window.vexpo.log) window.vexpo.log('logged in');
          } else {
            _this3.setState({ loggedIn: false });
            if (window.vexpo && window.vexpo.sound) window.vexpo.sound.shush();
            if (window.vexpo && window.vexpo.log) window.vexpo.log('logged out');
          }
        });
      }
      this.attemptLogin();
    }
    /** @method render
      * Renders the component
      */

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (!this.state.loggedIn) {
        // Firebase must be initialized if user authentication
        // is required.
        if (!window.vexpo.firebase) {
          return _react2.default.createElement(ServerError, { message: "Firebase not initialized" });
        }
        if (this.props.isSample) {
          // Sample shows have a simple clickthrough
          // to make sure the user interacts with the page
          // before the rest of the app is loaded.
          return _react2.default.createElement(
            _sampleClickthrough2.default,
            { name: this.props.name, logo: this.props.logo, stage: this.props.stage },
            this.props.children
          );
        } else {
          // Enter the show with the option of showing the login link request
          return _react2.default.createElement(
            _simpleEntry2.default,
            { name: this.props.name, logo: this.props.logo, stage: this.props.stage },
            this.props.children,
            _react2.default.createElement(_requestLoginLink2.default, {
              name: this.props.name,
              show: this.state.showLoginRequest,
              message: this.state.loginRequestMessage,
              onExit: function onExit() {
                return _this4.setState({ showLoginRequest: false });
              }
            })
          );
        }
      } else {
        // Just render the expo
        return this.props.children;
      }
    }
  }]);

  return Auth;
}(_react.Component);

exports.default = Auth;


Auth.propTypes = {
  stage: _propTypes2.default.object.isRequired,
  logo: _propTypes2.default.string.isRequired,
  entry: _propTypes2.default.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/auth.js
// module id = 202
// module chunks = 0